import * as d3 from 'd3'

export default {
  methods: {

    chart_Controller(d) {         

      let actData = this.chartData.filter(f=> f.CDATE <= this.cutoff)

      // Bar Chart 
      this.chart.styles.filter(f=> f.type == 'BAR').forEach((st,i)=> {
        let data = (st.act == 'Y') ? actData : this.chartData
        this.draw_BarChart(data, st, i) // -----> below
      })

      // Line Chart 
      this.chart.styles.filter(f=> f.type == 'LINE').forEach((st,i)=> {
        let data = (st.act == 'Y') ? actData : this.chartData
        this.draw_LineChart(data, st)
      })
    },


    draw_BarChart(_data, _st, _sn) {
      
      _data.forEach((d,i)=> {
        let value = (d[_st.code] < 0) ? 0 : d[_st.code]
        this.canvasChart
        .append('rect')
        .attr('x', d.bxs[_sn])
        .attr('y', this.chart.height-this.primary.axis(value))
        .attr('width', _st.size).attr('height', this.primary.axis(value))
        .attr('fill', _st.color).attr('opacity', _st.opacity)
      })
    },


    draw_LineChart(_data, _st) {

      let lineFunc = d3.line()
      .x(d => d.mx)
      .y(d => this.secondary.axis(d[_st.code]))
      // Line Chart
      this.canvasChart
      .append('path')
      .attr('d', lineFunc(_data))
      .attr('stroke', _st.color).attr('stroke-width', _st.size)
      .attr('fill', 'none').attr('opacity', _st.opacity)

      _data.forEach((d,i)=> {
        // Node
        if(_st.node > 0) {
          this.canvasChart
          .append('circle')
          .attr('cx', d.mx)
          .attr('cy', this.secondary.axis(d[_st.code]))
          .attr('r', _st.node)
          .attr('fill', _st.color).attr('opacity', _st.opacity)
        }
      })

    },

  }
}